/* eslint-disable camelcase -- uses palette names from design source */
import {
  VulnerabilityConnectionInput,
  VulnerabilityFilters,
} from '@totem/components/vulnerabilities/overviewSummary/types';
import colors from '@totem/styles/colors';
import { Filter } from '@totem/types/common';
import { isNotNull } from '@totem/utilities/common';

export const commonStyles = {
  probability_confirmed: {
    color: colors.event.criticality.background.critical,
    fontWeight: 600,
  },
  probability_likely: {
    color: colors.event.criticality.background.major,
    fontWeight: 600,
  },
  probability_possible: {
    color: colors.event.criticality.background.warning,
    fontWeight: 600,
  },
  score_critical: {
    color: colors.event.criticality.background.critical,
    fontWeight: 600,
  },
  score_major: {
    color: colors.event.criticality.background.major,
    fontWeight: 600,
  },
  score_minor: {
    color: colors.event.criticality.background.minor,
    fontWeight: 600,
  },
  score_warning: {
    color: colors.event.criticality.background.warning,
    fontWeight: 600,
  },
  default: {
    color: colors.event.criticality.background.unknown,
    fontWeight: 600,
  },
};

export const getScoreStyle = (score: number) => {
  if (score < 0.1) {
    return commonStyles.score_warning;
  }
  if (score < 4.0) {
    return commonStyles.score_minor;
  }
  if (score < 7.0) {
    return commonStyles.score_major;
  }

  return commonStyles.score_critical;
};

export const getProbabilityStyle = (probability: string) => {
  switch (probability) {
    case 'Confirmed':
      return commonStyles.probability_confirmed;
    case 'Likely':
      return commonStyles.probability_likely;
    case 'Possible':
      return commonStyles.probability_possible;
    default:
      return commonStyles.default;
  }
};

export const buildVulnerabilityFilters = (
  input: VulnerabilityConnectionInput,
) => {
  const paramFilters: Filter[] = [];

  if (isNotNull(input)) {
    if (isNotNull(input.regionId) && input.regionId.length > 0) {
      paramFilters.push({
        field: 'regionId',
        values: input.regionId,
      });
    }
    if (isNotNull(input.buildingId) && input.buildingId.length > 0) {
      paramFilters.push({
        field: 'buildingId',
        values: input.buildingId,
      });
    }
    if (isNotNull(input.controlSystemId) && input.controlSystemId.length > 0) {
      paramFilters.push({
        field: 'controlSystemId',
        values: input.controlSystemId,
      });
    }
    if (isNotNull(input.ownerId) && input.ownerId.length > 0) {
      paramFilters.push({
        field: 'ownerId',
        values: input.ownerId,
      });
    }
    if (isNotNull(input.ownerType) && input.ownerType.length > 0) {
      paramFilters.push({
        field: 'ownerType',
        values: input.ownerType,
      });
    }
    if (isNotNull(input.status) && input.status.length > 0) {
      paramFilters.push({
        field: 'sources.vulnerabilities.status',
        values: input.status,
      });
    }
    if (isNotNull(input.probability) && input.probability.length > 0) {
      paramFilters.push({
        field: 'sources.vulnerabilities.probability',
        values: input.probability,
      });
    }
  }

  return paramFilters;
};

export const addVulnerabilityFilters = (
  currentFilters: Filter[],
  input: VulnerabilityFilters,
) => {
  if (isNotNull(input)) {
    if (isNotNull(input.regionId) && input.regionId.length > 0) {
      currentFilters.push({
        field: 'regionId',
        values: input.regionId,
      });
    }
    if (isNotNull(input.buildingId) && input.buildingId.length > 0) {
      currentFilters.push({
        field: 'buildingId',
        values: input.buildingId,
      });
    }
    if (isNotNull(input.controlSystemId) && input.controlSystemId.length > 0) {
      currentFilters.push({
        field: 'controlSystemId',
        values: input.controlSystemId,
      });
    }
    if (isNotNull(input.ownerId) && input.ownerId.length > 0) {
      currentFilters.push({
        field: 'ownerId',
        values: input.ownerId,
      });
    }
    if (isNotNull(input.ownerType) && input.ownerType.length > 0) {
      currentFilters.push({
        field: 'ownerType',
        values: input.ownerType,
      });
    }
    if (isNotNull(input.status) && input.status.length > 0) {
      currentFilters.push({
        field: 'sources.vulnerabilities.status',
        values: input.status,
      });
    }
    if (isNotNull(input.probability) && input.probability.length > 0) {
      currentFilters.push({
        field: 'sources.vulnerabilities.probability',
        values: input.probability,
      });
    }
  }
  return currentFilters;
};
